import { render, staticRenderFns } from "./IndustryDistribution.vue?vue&type=template&id=d4aa3078&scoped=true&"
import script from "./IndustryDistribution.vue?vue&type=script&lang=js&"
export * from "./IndustryDistribution.vue?vue&type=script&lang=js&"
import style0 from "./IndustryDistribution.vue?vue&type=style&index=0&id=d4aa3078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4aa3078",
  null
  
)

export default component.exports